import { FC } from "react";
import { GoalInfo, GoalType, PlayerInfo } from "../../types/fixtures/match";
import { getIconByGoalType } from "./MatchIcons";
import { Link } from "../../components";

interface GoalsProps {
    goals: GoalInfo[];
    align?: 'left' | 'right';
}

export const Goals: FC<GoalsProps> = ({ goals, align }) => {
    if (!goals.length) {
        return null;
    }

    return (
        <div>
            {goals.map((goal, index) => {
                const splitGoalee = goal.player.name.split(' ');
                const splitAssistant = goal.assist?.name?.split(' ')
                return (
                    <div key={index} className={"flex flex-row gap-1" + (align === 'right' ? ' justify-end' : '')}>
                        <div className={"" + (align === 'right' ? ' text-right' : '')}>
                            {goal.player.url && <Link to={goal.player.url} className="sm:hover:text-sky-500 transition-all">
                                {splitGoalee[0]}
                                <span className="hidden sm:inline"> {splitGoalee[1]}</span>
                            </Link>}
                            {!goal.player.url && (
                                <>
                                    <>{goal.player.name.split(' ')[0]}</>
                                    <span className="hidden sm:inline"> {splitGoalee[1]}</span>
                                </>
                            )}
                            {goal.assist && (
                                <span className="italic">
                                    <span> (</span>
                                    {goal.assist.url && <a href={goal.assist.url} className="sm:hover:text-sky-500 transition-all">
                                        {splitAssistant[0]}
                                        <span className="hidden sm:inline"> {splitAssistant[1]}</span>
                                    </a>}
                                    {!goal.assist.url && <> {splitAssistant[0]}<span className="hidden sm:inline"> {splitAssistant[1]}</span></>}
                                    <span>)</span>
                                </span>
                            )}
                        </div>
                        <span className="px-1">
                            {goal.time}' {getIconByGoalType(goal.type)}
                        </span>
                    </div>
                )
            })}
        </div>
    );
}